export const INCORRECT_PASS = {
  internalMessage: '1050',
  message: 'Incorrect password'
};
